import type { AppErrorCode } from '../types/domain'

export class AppError extends Error {
  constructor(
    public readonly code: AppErrorCode,
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message)
    this.name = 'AppError'
  }
}

type ErrorLike = { code?: string; message?: string; status?: number }

export function mapSupabaseError(error: unknown): AppError {
  if (error instanceof AppError) return error
  const source = (error ?? {}) as ErrorLike
  if (source.code === '23505') {
    return new AppError('CONFLICT', 'Este registro já existe.', error)
  }
  if (source.code === 'PGRST116') {
    return new AppError('NOT_FOUND', 'Registro não encontrado.', error)
  }
  if (source.status === 0 || source.message?.toLowerCase().includes('fetch')) {
    return new AppError('NETWORK', 'Não foi possível conectar. Verifique a internet e tente novamente.', error)
  }
  return new AppError('UNKNOWN', 'Não foi possível concluir a operação. Tente novamente.', error)
}

export function authError(): AppError {
  return new AppError('AUTH_INVALID', 'E-mail ou senha inválidos.')
}

export function errorMessage(error: unknown): string {
  return error instanceof AppError
    ? error.message
    : 'Não foi possível concluir a operação. Tente novamente.'
}
